import { ENV_DEV } from "./window";

const errors = {
  /**
   *
   * @param {String} original
   */
  timeOffsetsOnCoordinates: (original) => {
    if (ENV_DEV) {
      console.warn(
        `[TorusKit warn]: Time-based offsets cannot be used in the coordinate-based trigger such as scroll or mouse. Please change it into percents. Found in: \`${original}\`.`
      );
    }
  }
}

export default errors;